import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useMyContext } from '../../../../context/MyContext';
import Sidebar from '../../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../../component/b2b/navBar/b2bNavBar';
import '../../../../css/custom-scrollbar.css';
import { Base_Url, b2bRateCard } from '../../../../config/config';
import { FcMoneyTransfer } from "react-icons/fc";
import { toast } from 'react-toastify';
import { Truck, Package, MapPin, ChevronDown, Layers, Receipt, IndianRupee } from 'lucide-react';



const B2BRateCard = () => {
  const [zoneMetrics, setZoneMetrics] = useState({});
  const [showZoneInfo, setShowZoneInfo] = useState({});
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const [data, setData] = useState([]);
  const [expandedPartner, setExpandedPartner] = useState(null);
  const [showVasCharges, setShowVasCharges] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');

  const zoneMapping = {
    'n1': 'N1', 'n2': 'N2', 'n3': 'N3', 'n4': 'N4',
    'c1': 'C1', 'c2': 'C2',
    'w1': 'W1', 'w2': 'W2',
    's1': 'S1', 's2': 'S2', 's3': 'S3', 's4': 'S4',
    'e1': 'E1', 'e2': 'E2',
    'ne1': 'NE1', 'ne2': 'NE2'
  };

  useEffect(() => {
    fetchRateCardList();
  }, []);

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const fetchRateCardList = async () => {
    try {
      setLoading(true);
      const url = Base_Url + b2bRateCard;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token || '',
          cus_id: cus_id || '',
          'Content-Type': 'application/json',
        },
      });
      const result = await response.json();

      if (result.status === "SUCCESS") {
        setData(result.data);
        setZoneMetrics(result.zonemetrics || {}); // Set zone metrics from API
        if (result.data.length > 0) {
          setActivePartner(result.data[0].partner);
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Error fetching rate card data: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const [activePartner, setActivePartner] = useState(data.length > 0 ? data[0].partner : null);

  const parsePricingData = (pricingString) => {
    try {
      return JSON.parse(pricingString);
    } catch (error) {
      console.error('Error parsing pricing data:', error);
      return {};
    }
  };

  const parseVasData = (vasString) => {
    try {
      return JSON.parse(vasString.trim());
    } catch (error) {
      console.error('Error parsing VAS data:', error);
      return [];
    }
  };

  const getZonePricing = (pricingData, fromZone, toZone) => {
    if (!pricingData[fromZone] || !pricingData[fromZone][toZone]) {
      return '-';
    }
    return pricingData[fromZone][toZone];
  };

  const formatChargeValue = (charge) => {
    if (charge.charge_type === 'percent') {
      return `${charge.value}%`;
    } else if (charge.charge_type === 'per_kg') {
      return `₹${charge.value}/kg`;
    } else {
      return `₹${charge.value}`;
    }
  };

  const getPartnerLogo = (partner) => {
    const logos = {
      'delhivery': '/assets/images/Delhivery.png',
      'gati': '/assets/images/Gati.jpg',
      'movin': '/assets/images/movin.svg'
    };
    return logos[partner.toLowerCase()] || '/assets/images/delivary.png';
  };

  const handlePartnerClick = (partner) => {
    setExpandedPartner(expandedPartner === partner ? null : partner);
  };

  const toggleVasCharges = (partner) => {
    setShowVasCharges(prev => ({
      ...prev,
      [partner]: !prev[partner]
    }));
  };

  const toggleZoneInfo = () => {
    setShowZoneInfo(prev => ({
      ...prev,
      [activePartner]: !prev[activePartner]
    }));
  };

  const getZoneColor = (zone) => {
    const colors = {
      'N1': 'bg-blue-50 text-blue-700',
      'N2': 'bg-blue-50 text-blue-700',
      'N3': 'bg-indigo-50 text-indigo-700',
      'N4': 'bg-indigo-50 text-indigo-700',
      'C1': 'bg-violet-50 text-violet-700',
      'C2': 'bg-violet-50 text-violet-700',
      'W1': 'bg-pink-50 text-pink-700',
      'W2': 'bg-pink-50 text-pink-700',
      'S1': 'bg-red-50 text-red-700',
      'S2': 'bg-orange-50 text-orange-700',
      'S3': 'bg-amber-50 text-amber-700',
      'S4': 'bg-yellow-50 text-yellow-700',
      'E1': 'bg-green-50 text-green-700',
      'E2': 'bg-emerald-50 text-emerald-700',
      'NE1': 'bg-teal-50 text-teal-700',
      'NE2': 'bg-cyan-50 text-cyan-700'
    };
    return colors[zone] || 'bg-gray-100 text-gray-700';
  };
 const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
        <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />
                    
                          <NavBar />
                    
                          <div className="flex flex-1 overflow-hidden">
                    
                            {isToggleSidebar && (
                              <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
                                <Sidebar />
                              </div>
                            )}

        <div className={`mb-6 w-full flex flex-1 flex-col custom-scrollbar overflow-y-auto ${isDarkMode ? 'dark:bg-darkmodeColor text-white' : 'bg-gray-200'}`}>
          <div className="p-2 md:p-2 max-w-[1500px] mx-auto">

            {/* Header — clean and simple */}
            <motion.div
              initial={{ opacity: 0, y: -12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="mb-2"
            >
              <h1 className={`text-xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Rate Card Dashboard</h1>
              <p className={`text-sm mt-1 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Zone pricing, VAS charges and courier partner rates</p>
            </motion.div>

            {loading ? (
              <div className={`flex flex-col items-center justify-center h-64 rounded-2xl border ${isDarkMode ? 'border-gray-700 dark:bg-darkmodeColor' : 'border-gray-200 bg-white'}`}>
                <div className="relative h-10 w-10">
                  <div className="absolute inset-0 rounded-full border-4 border-gray-100 dark:border-gray-700"></div>
                  <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-gray-900 dark:border-t-gray-300 animate-spin"></div>
                </div>
                <p className={`mt-4 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`}>Fetching rate cards...</p>
              </div>
            ) : data.length === 0 ? (
              <div className={`rounded-2xl p-12 text-center border ${isDarkMode ? 'border-gray-700 dark:bg-darkmodeColor' : 'border-gray-200 bg-white'}`}>
                <div className="mx-auto mb-4 w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center">
                  <Package className="text-gray-400" size={24} />
                </div>
                <h3 className={`text-base font-semibold mb-1 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>No rate cards available</h3>
                <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  There are no courier partner rate cards to display at this time.
                </p>
              </div>
            ) : (
              <>
                {/* Tabs for Courier Partners */}
                <div className="flex flex-wrap gap-3 mb-4">
                  {data.slice(0, 3).map((item) => (
                    <button
                      key={item.id}
                      onClick={() => setActivePartner(item.partner)}
                      className={`relative flex-1 min-w-[140px] rounded-xl px-4 py-1 text-left transition-all border ${activePartner === item.partner
                        ? 'bg-gray-900 border-gray-900 shadow-sm'
                        : isDarkMode
                          ? 'bg-gray-800/50 border-gray-700 text-gray-300'
                          : 'bg-white border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      <p className={`text-[11px] uppercase tracking-wide mb-0.5 ${activePartner === item.partner ? 'text-gray-400' : isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                        Partner
                      </p>
                      <span className={`flex items-center gap-2 text-base font-semibold capitalize ${activePartner === item.partner ? 'text-white' : isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>
                        {activePartner === item.partner && <span className="w-1.5 h-1.5 rounded-full bg-white" />}
                        {item.partner}
                      </span>
                    </button>
                  ))}
                </div>

                {/* Zone Metrics Section */}
                {Object.keys(zoneMetrics).length > 0 && (
                  <div className={`rounded-2xl overflow-hidden mb-4 border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                    <button
                      onClick={toggleZoneInfo}
                      className={`w-full p-3 flex items-center justify-between transition-all ${isDarkMode ? 'bg-gray-800/60 text-white' : 'bg-gray-50 text-gray-900'}`}
                    >
                      <span className="font-semibold flex items-center gap-2 text-sm sm:text-base">
                        <MapPin className={isDarkMode ? 'text-gray-300' : 'text-gray-500'} size={18} />
                        Zone Information &amp; Coverage Areas
                      </span>
                      <ChevronDown
                        className={`w-5 h-5 transition-transform duration-300 ${isDarkMode ? 'text-gray-300' : 'text-gray-400'} ${showZoneInfo[activePartner] ? 'rotate-180' : ''}`}
                      />
                    </button>

                    <AnimatePresence initial={false}>
                      {showZoneInfo[activePartner] && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.25 }}
                          className={`${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'} overflow-hidden`}
                        >
                          <div className="p-2 space-y-1 max-h-96 overflow-y-auto custom-scrollbar">
                            {Object.entries(zoneMetrics).map(([zone, locations], idx) => (
                              <div
                                key={zone}
                                className={`flex flex-col sm:flex-row sm:items-center gap-3 py-2.5 ${idx !== Object.entries(zoneMetrics).length - 1 ? `border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}` : ''}`}
                              >
                                <div className="flex items-center gap-2 sm:w-28 shrink-0">
                                  <span className={`px-2.5 py-1 rounded-md font-medium text-xs ${getZoneColor(zone)}`}>
                                    {zone}
                                  </span>
                                </div>
                                <div className="flex flex-wrap gap-1.5 flex-1">
                                  {locations.map((location, locIdx) => (
                                    <span
                                      key={locIdx}
                                      className={`px-2 py-0.5 rounded-md border text-xs ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-50 text-gray-600'}`}
                                    >
                                      {location}
                                    </span>
                                  ))}
                                </div>
                                <span className={`text-xs font-medium shrink-0 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`}>{locations.length} areas</span>
                              </div>
                            ))}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                )}

                {/* Content for Active Partner */}
                {(() => {
                  const activeItem = data.find(item => item.partner === activePartner);
                  if (!activeItem) return null;
                  const pricingData = parsePricingData(activeItem.zone_pricing);
                  const vasCharges = parseVasData(activeItem.vas_pricing);
                  const activeCharges = vasCharges.filter(charge => charge.is_active);
                  const zones = Object.keys(pricingData);

                  return (
                    <motion.div
                      key={activePartner}
                      initial={{ opacity: 0, y: 8 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      className={`${isDarkMode ? 'dark:bg-darkmodeColor border border-gray-700' : 'bg-white border border-gray-200'} rounded-2xl overflow-hidden`}
                    >
                      {/* Partner Header */}
                      <div className={`p-2 flex items-center justify-between ${isDarkMode ? 'bg-gray-800/60' : 'bg-gray-50'}`}>
                        <div className="flex items-center gap-2">
                          <div className="bg-white p-2 rounded-xl border border-gray-200">
                            <img
                              src={getPartnerLogo(activeItem.partner)}
                              alt={`${activeItem.partner} logo`}
                              className="w-9 h-9 object-contain"
                            />
                          </div>
                          <div className="text-left">
                            <h2 className={`text-xl font-bold capitalize ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>{activeItem.partner}</h2>
                            <span className={`inline-flex items-center gap-1 text-xs mt-1 font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                              <Layers size={12} /> {zones.length} zones available
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-4 space-y-4">
                        {/* VAS Charges Section */}
                        {activeCharges.length > 0 && (
                          <div className={`rounded-2xl overflow-hidden border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                            <button
                              onClick={() => toggleVasCharges(activeItem.partner)}
                              className={`w-full p-3 flex items-center justify-between transition-all ${isDarkMode ? 'bg-gray-800/60 text-white' : 'bg-gray-50 text-gray-900'}`}
                            >
                              <span className="font-semibold flex items-center gap-2 text-sm sm:text-base">
                                <Receipt className={isDarkMode ? 'text-gray-300' : 'text-gray-500'} size={18} />
                                VAS Charges
                                <span className={`ml-1 text-[11px] px-2 py-0.5 rounded-full ${isDarkMode ? 'bg-gray-700 text-gray-200' : 'bg-gray-200 text-gray-700'}`}>{activeCharges.length}</span>
                              </span>
                              <ChevronDown
                                className={`w-5 h-5 transition-transform duration-300 ${isDarkMode ? 'text-gray-300' : 'text-gray-400'} ${showVasCharges[activeItem.partner] ? 'rotate-180' : ''}`}
                              />
                            </button>

                            <AnimatePresence initial={false}>
                              {showVasCharges[activeItem.partner] && (
                                <motion.div
                                  initial={{ height: 0, opacity: 0 }}
                                  animate={{ height: 'auto', opacity: 1 }}
                                  exit={{ height: 0, opacity: 0 }}
                                  transition={{ duration: 0.25 }}
                                  className={`overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}
                                >
                                  <div className=" space-y-1">
                                    {activeCharges.map((charge, idx) => (
                                      <div key={idx} className={`pb-3 ${idx !== activeCharges.length - 1 ? `border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}` : ''}`}>
                                        <div className="flex items-end gap-2">
                                          <span className="font-medium text-sm">{charge.label}</span>
                                          <span className={`flex-1 border-b border-dotted ${isDarkMode ? 'border-gray-600' : 'border-gray-200'} mb-1`} />
                                          <span className={`font-semibold text-base ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>
                                            {formatChargeValue(charge)}
                                          </span>
                                        </div>
                                        <div className="flex flex-wrap items-center gap-3 mt-1.5">
                                          <span className={`text-[11px] uppercase tracking-wide ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                                            {charge.charge_key}
                                          </span>
                                          <span className={`px-2 py-0.5 rounded-md text-[11px] ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-50 text-gray-600'}`}>
                                            {charge.charge_type}
                                          </span>
                                          {charge.condition_value && (
                                            <span className={`text-[11px] ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{charge.condition_value}</span>
                                          )}
                                          {charge.min_value && (
                                            <span className="text-[11px] text-gray-400">min ₹{charge.min_value}</span>
                                          )}
                                          {charge.max_value && (
                                            <span className="text-[11px] text-gray-400">max ₹{charge.max_value}</span>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </motion.div>
                              )}
                            </AnimatePresence>
                          </div>
                        )}

                        {/* Zone Pricing Table */}
                        <div className={`rounded-2xl overflow-hidden border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                          <div className={`p-2 flex items-center gap-2 ${isDarkMode ? 'bg-gray-800/60' : 'bg-gray-200'}`}>
                            <IndianRupee className={isDarkMode ? 'text-gray-300' : 'text-gray-500'} size={18} />
                            <h3 className={`font-semibold text-sm sm:text-base ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Zone Pricing Matrix</h3>
                          </div>
                          <div className="overflow-x-auto">
                            <table className="min-w-full">
                              <thead className={`${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                                <tr>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>Zone</th>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>To North (N1-N4)</th>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>To Central (C1-C2)</th>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>To West (W1-W2)</th>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>To South (S1-S4)</th>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>To East (E1-E2)</th>
                                  <th className={`px-4 py-1 text-left text-[11px] uppercase tracking-wider border-b ${isDarkMode ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-400'}`}>To Northeast (NE1-NE2)</th>
                                </tr>
                              </thead>
                              <tbody>
                                {zones.map((zone, zoneIndex) => (
                                  <tr
                                    key={zone}
                                    className={`${zoneIndex % 2 === 0
                                      ? isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'
                                      : isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50/60'
                                      } hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors`}
                                  >
                                    <td className={`px-4 py-1 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <span className={`font-semibold text-sm px-2.5  rounded-md ${isDarkMode ? 'bg-gray-800 text-gray-100' : 'bg-gray-900 text-white'}`}>
                                        {zoneMapping[zone] || zone.toUpperCase()}
                                      </span>
                                    </td>
                                    <td className={`px-4 py-1 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <div className="grid grid-cols-2 gap-2 text-sm">
                                        {['n1', 'n2', 'n3', 'n4'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{z.toUpperCase()}:</span>
                                            <span className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['c1', 'c2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{z.toUpperCase()}:</span>
                                            <span className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['w1', 'w2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{z.toUpperCase()}:</span>
                                            <span className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <div className="grid grid-cols-2 gap-2 text-sm">
                                        {['s1', 's2', 's3', 's4'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{z.toUpperCase()}:</span>
                                            <span className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['e1', 'e2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{z.toUpperCase()}:</span>
                                            <span className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                    <td className={`px-4 py-3 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-100'}`}>
                                      <div className="grid grid-cols-1 gap-2 text-sm">
                                        {['ne1', 'ne2'].map(z => (
                                          <div key={z} className="flex items-center gap-1">
                                            <span className={`font-medium ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>{z.toUpperCase()}:</span>
                                            <span className={`font-semibold ${isDarkMode ? 'text-gray-100' : 'text-gray-800'}`}>₹{getZonePricing(pricingData, zone, z)}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  );
                })()}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );

};

export default B2BRateCard;